import React from 'react';

import { Icon } from '@chakra-ui/react';
import { MdPerson } from 'react-icons/md';

// Imports des vues
import Profile from 'views/admin/profile';

// Route pour les demandes (missions du médecin)
const MedecinDemandes = React.lazy(() => import('views/medecin/demandes'));
// Route pour la création de demande
const CreateDemande = React.lazy(() => import('views/medecin/demandes/create'));
// Route pour le tableau de bord médecin
const MedecinDashboard = React.lazy(() => import('views/medecin/default'));

const routesMedecin = [
    {
        name: 'Créer une demande',
        layout: '/medecin',
        path: '/demandes/create',
        component: <CreateDemande />,
        hidden: true,
    },
    {
        category: true,
        name: 'Tableau de bord et analyses',
        items: [
            {
                name: 'Tableau de bord',
                layout: '/medecin',
                path: '/default',
                icon: 'tableaudebord.png',
                component: <MedecinDashboard />,
            },
        ],
    },
    {
        category: true,
        name: 'Gestion de demande',
        items: [
            {
                name: 'Les Demandes',
                layout: '/medecin',
                path: '/demandes',
                icon: 'missions.png',
                component: <MedecinDemandes />,
            },
        ],
    },
    {
        category: true,
        name: 'Sécurité et accès',
        items: [
            {
                name: 'Paramètres',
                layout: '/medecin',
                path: '/profile',
                icon: 'profile.png',
                component: <Profile />,
            },
        ],
    },
];

export default routesMedecin;
